<template>
	<admin-keycloak></admin-keycloak>
</template>

<script>
import AdminKeycloak from '../adminPage/keycloak/AdminKeycloak.vue'

export default {
	components: { AdminKeycloak },
}

</script>

<style>

</style>
